import { HotelOrLandProgrammeFragment } from "types/graphql-types";

export const hasMandatoryFields = (
  x: HotelOrLandProgrammeFragment
): x is HotelOrLandProgrammeFragment &
  Required<Pick<HotelOrLandProgrammeFragment, "name" | "image">> =>
  !!x.name && !!x.image;
